import useAccount from './useAccount';
// import useComment from './useComment';
import useConcept from './useConcept';
import useFeature from './useFeature';
import useLanguage from './useLanguage';
import useMessaging from './useMessaging';
import useConversation from './useConversation';
import useReservation from './useReservation';
// import useTimeline from './useTimeline';
// import useAttachment from './useAttachment';
import useAdminRole from './useAdminRole';
import useAdminGroup from './useAdminGroup';
import useUserConcepts from './useUserConcepts';
// import useTransaction from './useTransaction';
// import usePaymentStat from "./usePaymentStat";
// import useEvent from './useEvent';
// import useCashlessTransaction from './useCashlessTransaction';
// import useCashlessTopups from './useCashlessTopups';
// import useGate from './useGate';
// import useHostScans from './useHostScans';

const useResource = () => {
  const accountsApi = useAccount('accounts', 'account');
  const conceptsApi = useConcept('concepts', 'concept');
  const featuresApi = useFeature('features', 'feature');
  const languagesApi = useLanguage('languages', 'language');
  const messagingApi = useMessaging('messagings', 'messaging');
  const conversationsApi = useConversation('conversations', 'conversation');
  const reservationsApi = useReservation('reservations', 'reservation');
  // const usersApi = useUser("guests", "guest");
  // const commentsApi = useComment('comments', 'comment');
  // const timeLinesApi = useTimeline('timelines', 'timeline');
  // const attachmentsApi = useAttachment('attachments', 'attachment');
  const adminRolesApi = useAdminRole('adminRoles', 'adminRole');
  const adminGroupsApi = useAdminGroup('adminGroups', 'adminGroup');
  const userConceptsApi = useUserConcepts('userConcepts', 'userConcept');
  // const eventApi = useEvent('events', 'event');
  // const cashlessTransactionApi = useCashlessTransaction(
  //   'cashlessTransactions',
  //   'cashlessTransaction',
  // );
  // const cashlessTopupsApi = useCashlessTopups(
  //   'cashlessTopups',
  //   'cashlessTopup',
  // );
  // const ticketsScanApi = useHostScans('hostScans', 'hostScan');

  // const gateAPI = useGate('gates', 'gate');
  // const transactionsApi = useTransaction('transactions', 'transaction');
  // const paymentStatsApi = usePaymentStat("paymentStats", "paymentStat");

  return {
    ...adminGroupsApi,
    ...adminRolesApi,
    ...accountsApi,
    ...conceptsApi,
    ...userConceptsApi,
    ...featuresApi,
    ...languagesApi,
    ...messagingApi,
    ...conversationsApi,
    ...reservationsApi,
    // ...usersApi,
    // ...commentsApi,
    // ...timeLinesApi,
    // ...attachmentsApi,
    // ...userConceptsApi,
    // ...transactionsApi,
    // ...paymentStatsApi,
    // ...eventApi,
    // ...cashlessTransactionApi,
    // ...cashlessTopupsApi,
    // ...gateAPI,
    // ...ticketsScanApi,
  };
};

export default useResource;
